import styled, { css } from 'styled-components';

const AmountTdStyle = css`
  .popover-amount-td,
  .amount-td {
    display: flex;
    align-items: center;

    /* justify-content: flex-end; */
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;

    .currency {
      min-width: 18px;
      margin-right: 8px;
      text-align: left;
      white-space: nowrap;

      /* text-overflow: ellipsis; */
    }

    .value {
      flex: 1 1 90px;

      /* min-width: 90px; */
      max-width: 100px;
      overflow: hidden;
      text-align: right;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span.refAmount {
      font-size: 90%;
      font-style: italic;
    }

    .ant-tag {
      margin-right: 0;
    }
  }
`;

const StyledAmountTd = styled.div`
  ${AmountTdStyle}
`;

export {
    StyledAmountTd,
    AmountTdStyle as PopoverAmountTdStyle,
};
